"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";
import { isPublicProfilePath } from "@/lib/is-public-profile-path";

interface ConditionalNavProps {
  children: ReactNode;
  hideOnFeed?: boolean;
  hideOnMobileProfile?: boolean;
}

export default function ConditionalNav({
  children,
  hideOnFeed = false,
  hideOnMobileProfile = false,
}: ConditionalNavProps) {
  const pathname = usePathname();
  const isListingDetailPage = pathname?.includes("/listings/") && !pathname?.endsWith("/listings");
  const isFeedPage = pathname === "/feed" || pathname?.startsWith("/feed/");
  const isProfilePage = isPublicProfilePath(pathname);

  if (hideOnFeed && isFeedPage) {
    return null;
  }

  if (hideOnMobileProfile && (isProfilePage || pathname === "/profile/edit")) {
    return <div className="max-md:hidden">{children}</div>;
  }

  // Listing detail is immersive: chrome (bottom nav) shows on desktop only.
  if (isListingDetailPage) {
    return <div className="md:block hidden">{children}</div>;
  }

  return <>{children}</>;
}
